import React, { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDropdownFilter } from '../Custom_Hooks/useDropdownFilter';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../redux/actions/action-creator';




// Utility function to separate compound units into simple units
const separateCompoundUnits = (mainUnitName, alternateUnitName) => {
    const units = [];
    
    // Function to extract simple units from compound unit string
    const extractUnitsFromString = (unitString) => {
      if (!unitString || unitString === 'Not Applicable' || unitString === '') {
        return [];
      }
      
      // Pattern to match compound units like "Box of 10 Nos", "Box of 1 kg", "Cont of 5 li"
      const compoundPattern = /(\w+)\s+of\s+(\d+)\s+(\w+)/i;
      const match = unitString.match(compoundPattern);
      
      if (match) {
        // Extract the units from compound unit
        const [, containerUnit, quantity, baseUnit] = match;
        return [
          { name: containerUnit, id: `${containerUnit}_container` },
          { name: baseUnit, id: `${baseUnit}_base` }
        ];
      } else {
        // If it's a simple unit, return as is
        return [{ name: unitString, id: `${unitString}_simple` }];
      }
    };
    
    // Extract units from main unit name
    const mainUnits = extractUnitsFromString(mainUnitName);
    units.push(...mainUnits);
    
    // Extract units from alternate unit name
    const alternateUnits = extractUnitsFromString(alternateUnitName);
    units.push(...alternateUnits);
    
    // Remove duplicates based on name
    const uniqueUnits = units.filter((unit, index, self) => 
      index === self.findIndex(u => u.name === unit.name)
    );
    
    return uniqueUnits;
  };

const DropdownVoucherDynamicInput = forwardRef((
    {
        custom_class,
        title,
        state,
        input_value,
        input_key,
        input_id,
        input_blc,
        rawData,
        data,
        setData,
        setSubmitConfirm,
        inputRefs,
        index,
        refs,
        narr_ref,
        isDynamic,
        handleDropdownClick
    }, ref) => {


    const dropdownRef = useRef(null)
    const dispatch = useDispatch();

    const { filteredData } = useDropdownFilter({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
        isDynamic: isDynamic
    });
    let is_dropdown_clicked = false;

    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        onItemSelect: (item) => {
            is_dropdown_clicked = false;
                selectedDataHandle(item)
        },
        onItemAltCSelect: () => {
            dispatch(closeModal(`${input_key}${index}`));
            if (input_key === 'item_name') {
                dispatch(openModal("stockItemCreate"));
            } else if (input_key === 'godown_location') {
                dispatch(openModal("godownCreateVoucher"));
            } else {
                dispatch(openModal("ledgerCreate"));
            }
        },
        input_value,
    });

    const selectedDataHandle = (item) => {
        console.log("item",item)
        const new_data = data?.data?.filter((item1) => {
            return String(item1.particular_ledger_id !== '' && item1.particular_ledger_id !== null && item1.particular_ledger_id) === String(item.id);
        });
        let get_amount

        if (new_data.length > 0) {
            const amount = new_data.slice(-1).map((item, index) => { return (item.particular_ledger_balance) })
            get_amount = amount[0]
        } else {
            get_amount = item?.opening_balance
        }

        setData((prevData) => {

            const updatedData = { ...prevData };
            if (typeof index !== "number") {
                updatedData[input_key] = (item?.ledger_name==="End of List"?'':item?.ledger_name )|| item?.name || item?.symbol;
            } else if (typeof index === "number") {
                if(input_key === 'payment_ledger_account'){
                    updatedData.payment_allocation = updatedData.payment_allocation.map((item_data, i) =>
                        i === index ? {
                            ...item_data,
                            [input_key]: item?.ledger_name,
                            [input_id]: item?.id || '',
                            [input_blc]: get_amount || ''
                        } : item_data
                    )
                }
                data?.voucher_type_name === 'Sales' || data?.voucher_type_name === 'Purchase' ?
                    updatedData.data_item = updatedData.data_item.map((item_data, i) =>{
                        if(input_key === 'item_name'){
                            if(item.name==='End of List'){
                                return(
                                    i === index ? {
                                        ...item_data,
                                        [input_key]: '',
                                        [input_id]: ''
                                    } : item_data
                                )
                            }
                            if(item_data.item_name=== item.name){
                                return (
                                    i === index ? {
                                        ...item_data,
                                        [input_key]: item?.name,
                                        [input_id]: item?.id
                                    } : item_data
                                )
                            }
                        return(
                        i === index ? {
                            ...item_data,
                            [input_key]: item?.name,
                            [input_id]: item?.id || '',
                            ['is_unit_available']: (item?.unit_name && item.unit_name !== 'Not Applicable' && item.unit_name !== '') ? true : false,
                            ['where_unit_num']: item?.unit_name === 'Not Applicable' || item?.unit_name === '' ? '' : item?.where_unit,
                            ['where_alternate_unit_num']: item?.unit_name === 'Not Applicable' || item?.unit_name === '' ? '' : item?.where_alternate_unit,
                            ['main_unit_name']: item?.unit_name === 'Not Applicable' || item?.unit_name === '' ? '' : item?.unit_name,
                            ['item_alternate_unit']: item?.unit_name === 'Not Applicable' || item?.unit_name === '' || item?.alt_unit_name === 'Not Applicable' || item?.alt_unit_name === '' ? '' : item?.alt_unit_name,
                            ['item_units']: separateCompoundUnits(item?.unit_name,item?.alt_unit_name),
                            ['default_unit_name']:item?.default_unit_name ,
                            ['per_unit']:item?.default_unit_rate,
                            // [input_blc]: get_amount || ''
                        } : item_data
                    )
                    }else{
                        if(item?.name==='End of List'){
                            return(
                                i === index ? {
                                    ...item_data,
                                    [input_key]: '',
                                    [input_id]: ''
                                } : item_data
                            )
                        }else{
                        return(
                            i === index ? {
                                ...item_data,
                                [input_key]: item?.name,
                                    [input_id]: item?.id || '',
                                } : item_data
                            )
                        }
                    }
                }
                    
                    
                    ) : updatedData.data = updatedData.data.map((item_data, i) =>
                    {
                        if(item?.ledger_name==='End of List'){
                            return(
                                i === index ? {
                                    ...item_data,
                                    [input_key]: '',
                                    [input_id]: ''
                                } : item_data
                            )
                        }
                        return(
                        i === index ? {
                            ...item_data,
                            [input_key]: (item?.ledger_name==="End of List"?'':item?.ledger_name ),
                            [input_id]: item?.id || '',
                            [input_blc]: get_amount || ''
                        } : item_data
                    )
                    }
                    );
            }
            return updatedData;
        });
        dispatch(closeModal(`${input_key}${index}`))

        if (handleDropdownClick && is_dropdown_clicked) {
            handleDropdownClick(input_key, item?.ledger_name || item?.name || item?.symbol,index);
        }
        
    }

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
        <div className={`${custom_class ? custom_class : 'dropdown-content-list'} ${state ? 'show-list' : ''}`}>
            <div className='col' style={{ background: 'skyblue', position: 'sticky', top: 0 }}>
                {title}
            </div>

            <div id='data' ref={dropdownRef} style={{ overflowY: 'auto', maxHeight: '80.5vh' }}>
                {
                    Array.isArray(filteredData) && filteredData?.map((key, number) => {
                        const name = key?.ledger_name || key?.name || key?.symbol;
                        const formal_name = key?.formal_name
                        const type = key?.type
                        const balance = key?.opening_balance;
                        const id = key?.id;
                        const index_1 = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                        return (
                            <Link
                                className={`list  ${number === selectedItemIndex ? 'selected' : ''}`}
                                id='list'
                                key={number}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedItemIndex(number);
                                    if (number === selectedItemIndex) {
                                        const selectedItem = filteredData[number];
                                        is_dropdown_clicked = true;
                                            selectedDataHandle(selectedItem)
                                    }
                                }}
                            >
                                <div className='row m-0'>
                                    <div className={formal_name ? 'col-6 p-0' : 'col-12 p-0'}>
                                        {index_1 !== -1 ? (
                                            < >
                                                {name?.substring(0, index_1)}
                                                <span style={{ color: 'red' }}>{name?.substring(index_1, index_1 + input_value?.length)}</span>
                                                {name?.substring(index_1 + input_value?.length)}
                                            </>
                                        ) : (
                                            name
                                        )}

                                    </div>
                                    {
                                        formal_name ?
                                            <div className='col-6'>
                                                {formal_name && type === 'Simple' ? `(${formal_name})` : null}
                                            </div> : null
                                    }
                                </div>
                            </Link>
                        );
                    })
                }

            </div>
        </div>
    )
})

export default React.memo(DropdownVoucherDynamicInput)
